export default __webpack_public_path__ + "static/media/designAndroid.330a9d0c.webp";